(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-sign-role', {
            parent: 'entity',
            url: '/task-sign-role?page&sort&search',
            data: {
                authorities: ['ROLE_SIGN_ROLE'],
                pageTitle: 'c3WebApp.certificateRequestBatch.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-sign-role/tasks.html',
                    controller: 'TaskSignRoleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('certificateRequestBatch');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-sign-role-detail', {
            parent: 'entity',
            url: '/task-sign-role/{id}?page&sort&search',
            data: {
                authorities: ['ROLE_SIGN_ROLE'],
                pageTitle: 'c3WebApp.certificateRequestBatch.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-sign-role/task-detail.html',
                    controller: 'TaskSignRoleDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('certificateRequestBatch');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskSignRole', function($stateParams, TaskSignRole) {
                	return TaskSignRole.get({id : $stateParams.id}).$promise;
                }],
                config: ['$stateParams', 'TaskSignRoleConfig', function($stateParams, TaskSignRoleConfig) {
                	return TaskSignRoleConfig.get().$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        });
    }

})();
